import { createContext, Dispatch, SetStateAction } from "react"

export type EasyPopoverContextProps = {
    anchor: HTMLButtonElement | null
    setAnchor: Dispatch<SetStateAction<HTMLButtonElement | null>>
}

export const EasyPopoverContext = createContext<EasyPopoverContextProps | undefined>(undefined)
